import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const crispLocale = (lng) => {
  const code = (lng || 'en').toLowerCase();
  if (code.startsWith('uk')) return 'uk';
  if (code.startsWith('ro')) return 'ro';
  return 'en';
};

export function openCrispChat() {
  if (typeof window === 'undefined' || !window.$crisp) return;
  window.$crisp.push(['do', 'chat:open']);
}

export default function CrispChat() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const syncLocale = (lng) => {
      if (typeof window === 'undefined' || !window.$crisp) return;
      window.$crisp.push(['set', 'session:data', [[['language', crispLocale(lng)]]]]);
    };

    syncLocale(i18n.language);
    i18n.on('languageChanged', syncLocale);
    return () => i18n.off('languageChanged', syncLocale);
  }, [i18n]);

  return null;
}
